import React from "react";
import { Modal } from "@/components/ui";
import { fmt, fmtDate } from "@/lib/formatters";
import { CreditCard, Wallet, Calendar, Banknote, ShieldCheck } from "lucide-react";

export const ViewReceivedAmountModal = ({ isOpen, onClose, receipt }) => {
  if (!receipt) return null;

  const Card = ({ label, v, fullWidth = false }) => (
    <div className={`bg-slate-50 rounded-lg p-3 ${fullWidth ? 'col-span-2' : ''}`}>
      <div className="text-[10px] text-slate-500 mb-0.5 uppercase font-bold tracking-wider opacity-70">
        {label}
      </div>
      <div className="text-xs font-semibold text-brand-dark">
        {v !== undefined && v !== null && v !== "" ? String(v) : "—"}
      </div>
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Receipt Details: #${String(receipt._id || "").slice(-6).toUpperCase()}`} size="max-w-lg">
      <div className="space-y-5">
        <div className="grid grid-cols-2 gap-3">
          <Card label="Customer Name" v={receipt.customer?.customerName || receipt.customer?.name} />
          {receipt.customer?.phone && (
            <Card label="Phone" v={receipt.customer?.phone} />
          )}

          <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
            <label className="text-[11px] font-bold text-emerald-600 uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
              <Wallet size={14} /> Payment Details
            </label>
          </div>
          
          <Card label="Amount Received" v={`₹${fmt(receipt.amount)}`} />
          <Card label="Payment Date" v={receipt.date ? fmtDate(receipt.date) : "—"} />
          <Card label="Payment Mode" v={receipt.paymentMethod?.replace(/_/g, " ")} />

          <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
            <label className="text-[11px] font-bold text-brand-blue uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
              <CreditCard size={14} /> Transaction Info
            </label>
          </div>

          {receipt.paymentData?.transactionId && <Card label="Transaction ID / Ref" v={receipt.paymentData.transactionId} />}
          {receipt.paymentData?.bankName && <Card label="Bank / Issuing Bank" v={receipt.paymentData.bankName} />}
          {receipt.paymentData?.branch && <Card label="Branch" v={receipt.paymentData.branch} />}
          {receipt.paymentData?.upiPhone && <Card label="UPI Phone Number" v={receipt.paymentData.upiPhone} />}
          {receipt.paymentData?.chequeNumber && <Card label="Cheque Number" v={receipt.paymentData.chequeNumber} />}
          {receipt.paymentData?.chequeDate && <Card label="Cheque Date" v={receipt.paymentData.chequeDate} />}
          {receipt.paymentData?.receiverName && <Card label="Receiver Name" v={receipt.paymentData.receiverName} />}
          {receipt.paymentData?.receiverPhone && <Card label="Receiver Phone" v={receipt.paymentData.receiverPhone} />}
          
          {receipt.remarks && <Card label="Internal Remarks" v={receipt.remarks} fullWidth />}
        </div>
      </div>
    </Modal>
  );
};




